module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABZElEQVQ4T43SzavOURTF8c+6ZEoyYGZAKUIpI1ImZGBgQobykqFIUldK18x/IDJhIJG83ySGjBTJS2bMDIQZtk6dR79y7/M49avT7+zzPWvvtWKwqmoKa/Auyc/h2Xz7jA6qajfOYwk+YHuS35MgqaqFeIBlOI37eIYrSS7+D2AdbmPV6MWqWo+HrZ0kX8dBmoJFeIkzSa634g54hK1J3o8F9AubcBcb8QWv8DTJ4YktDIY43V7ETmzoLWxL8maigq5iAR63L8m5qtqPGWxJ8mmijR2yHM9xLMmNqjqBI9iR5ONckL85GLTSHJjFviRPquoQzmJPn81Ukm+j+n8AXclm3MLBJPeqahcuo2WmpbUF7kKzfU7AAHIT00kuVdVq/OiAq3id5Oi8gA5pl+70oJ1K8qv/X9tsT7JyLKAXL8W1Lv8APvcZzSaZmQgYWHwSx/EdL7B37AzmsqyqFmMF3iapVvMHS6+FEZOQsEAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone.png
// module id = 5ng9
// module chunks = 1